import { BaseButtonSize, BaseButtonType } from './Button.enum';
const handleButtonColors = (variant = BaseButtonType.STANDARD, theme) => {
    switch (variant) {
        case BaseButtonType.INVERTED:
            return `
                background: ${theme.colors.ui01};
                color: ${theme.colors.interactivePrimary01};
                :hover { background: ${theme.colors.interactiveSecondary02}; }
                :hover:active { background: ${theme.colors.interactiveSecondary03}; }
            `;
        case BaseButtonType.PLAIN:
            return `
                background: ${theme.colors.interactiveSecondary01};
                color: ${theme.colors.disabled03};
                :hover { background: ${theme.colors.interactiveSecondary02}; }
                :focus-visible { background: ${theme.colors.interactiveSecondary02}; }
                :hover:active { background: ${theme.colors.interactiveSecondary03}; }
            `;
        case BaseButtonType.DISABLED:
            return `
                background: ${theme.colors.disabled02};
                color: ${theme.colors.disabled03};
            `;
        case BaseButtonType.STANDARD:
        default:
            return `
                background: ${theme.colors.interactivePrimary01};
                color: ${theme.colors.ui01};
                :hover { background: ${theme.colors.interactivePrimary02}; }
                :focus-visible { background: ${theme.colors.interactivePrimary02}; }
                :hover:active { background: ${theme.colors.interactivePrimary03}; }
            `;
    }
};
const handleButtonSize = (size = BaseButtonSize.MEDIUM, theme) => {
    switch (size) {
        case BaseButtonSize.BIG:
            return `
                padding: 12px 16px; 
                font-size: ${theme.fontSizes.sizeMd2};
                line-height: 1.5rem;
            `;
        case BaseButtonSize.SMALL:
            return `
                padding: 8px 12px; 
                font-size: ${theme.fontSizes.sizeSm3};
                line-height: 1rem;
            `;
        case BaseButtonSize.MEDIUM:
        default:
            return `
                padding: 8px 16px; 
                font-size: ${theme.fontSizes.sizeMd1};
                line-height: 1.5rem;
            `;
    }
};
const handleButtonRound = (round = false, theme) => {
    if (!round)
        return 'border-radius: 4px;';
    return `
        border-radius: 50%;
        width: 48px; 
        height: 48px;
        use {
            color: ${theme.colors.ui01};
        }
    `;
};
export { handleButtonColors, handleButtonRound, handleButtonSize };
//# sourceMappingURL=button.helpers.js.map